import { videoManagerRoutes } from './videoManager.routes';
import { adminRoutes } from './admin.routes';
import { debugRoutes } from './debug.routes';
import { appManagerRoutes  } from './appManager.routes';
import { mainHubRoutes  } from './mainHub.routes';
import { sportRoomRoutes  } from './sportRoom.routes';
import { clientPortalRoutes } from './clientPortal.routes';
export const appRoutes = {
  videoManagerRoutes,
  adminRoutes,
  debugRoutes,
  appManagerRoutes,
  mainHubRoutes,
  sportRoomRoutes,
  clientPortalRoutes,
};